export function rolRequiereEmpresaUnica(rol) {
  void rol;
  return false;
}

export function rolesParaCrearUsuario(roles) {
  return (roles || []).filter((rol) => rol?.name !== "super_admin");
}

export function accesoAlCambiarRol(rol, accesoActual) {
  if (rolRequiereEmpresaUnica(rol)) {
    return "una";
  }
  return accesoActual || "todas";
}
